<template>
  <div>
    <CollapseItems
      title-class-header="h6"
      title-weight-header="bold"
    >
      <template #title>
        <h5 class="font-weight-black">
          Instruções
        </h5>
      </template>
      <template #content>
        <div class="border-bottom p-4 bg-light text-black-50">
          <p class="mb-1 font-weight-bolder">
            Estamos preparando o Ciclo {{ selectedCycle.order }} personalizado para você.
          </p>
          <p class="mb-1">
            <b>PASSO 1</b>
          </p>
          <p class="mb-1">
            Selecione os conteúdos focados na sua área de interesse.
          </p>
          <p class="mb-1">
            <b>ATENÇÃO</b>: você só pode escolher um bloco temático. Cada bloco temático possui <b>4 módulos</b> que serão
            estudados nos próximos ciclos.
          </p>
          <span><b>LEGENDA</b></span>:
          <span
            v-for="(trail, index) in trails"
            :key="index"
            class="mb-1"
          >
            <b>{{ `&nbsp; ${trail.acronym} -` }}</b> {{ `${trail.name} &nbsp; &nbsp;` }}
          </span>
        </div>
      </template>
    </CollapseItems>
    <div class="p-4 text-black border-bottom d-flex flex-sm-row flex-column justify-content-md-between">
      <div class="d-flex align-center justify-content-center justify-content-sm-start">
        <span class="font-weight-bolder">
          Ciclo {{ selectedCycle.order }}: &nbsp;
        </span>
        {{ $moment(selectedCycle.begin).format('DD/MM/YYYY') }} a {{ $moment(selectedCycle.end).format('DD/MM/YYYY') }}
      </div>
    </div>
  </div>
</template>
<script>
import CollapseItems from "@/common/components/CollapseItems.vue";
import { mapGetters } from 'vuex';

export default {
  components: {
    CollapseItems,
  },
  computed: {
    ...mapGetters([
      'current_cycle',
      'selectedCycle',
      'authUser',
      'trails'
    ]),
  }
}


</script>
